export default "__VITE_ASSET__CMnd8S34__"